<section class="account-section card shadow-sm">
  <header class="section-header">
    <span class="section-icon"><i class="pi pi-pencil"></i></span>
    <div>
      <h2 class="section-title">{{ "user-profile-edit.edit-title" | translate }}</h2>
      <p class="section-subtitle">{{ "user-profile-edit.edit-subtitle" | translate }}</p>
    </div>
  </header>

  <form class="edit-grid" [formGroup]="editForm" (ngSubmit)="saveEdit()">
    <div class="edit-field">
      <label for="editNome" class="form-label">{{ "user-profile-edit.form-name" | translate }}</label>
      <input type="text" class="form-control" id="editNome" name="name" [formControl]="nameFormEdit"
        placeholder="Nome" />
    </div>
    <div class="edit-field">
      <label for="editEmail" class="form-label">{{ "user-profile-edit.form-email" | translate }}</label>
      <input type="text" class="form-control" id="editEmail" name="email" [formControl]="emailFormEdit"
        placeholder="email@email.com" />
    </div>
    <div class="edit-field">
      <label for="editUsuario" class="form-label">{{ "user-profile-edit.form-user" | translate }}</label>
      <input type="text" class="form-control" id="editUsuario" name="user" [formControl]="userFormEdit"
        placeholder="nome.nome" />
    </div>

    <div class="edit-actions">
      <p-button
        type="button"
        severity="secondary"
        [outlined]="true"
        icon="pi pi-times"
        [label]="'user-profile-edit.button-cancel' | translate"
        (onClick)="cancelEdit()"
      />
      <p-button
        type="submit"
        severity="success"
        icon="pi pi-check"
        [label]="'user-profile-edit.button-save' | translate"
      />
    </div>
  </form>
</section>
